import { faFlag } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';
import { ReportedPost } from '../model/moderation.types';

type Props = {
  post: ReportedPost;
  busy?: boolean;
  authorBlocked?: boolean;
  onRemove: () => void;
  onBlock: () => void;
  onApprove: () => void;
};

export const ReportedPostCard = ({
  post,
  busy = false,
  authorBlocked = false,
  onRemove,
  onBlock,
  onApprove,
}: Props) => (
  <div className="flex flex-col gap-3 rounded-[16px] border border-[#FCE4E4] p-4">
    <div className="flex items-center gap-2">
      <img
        src={post.authorAvatar}
        alt={post.authorName}
        className="h-9 w-9 rounded-full object-cover"
      />
      <div className="flex flex-col">
        <div className="flex items-center gap-2">
          <Typography
            as="span"
            variant="body"
            size="medium"
            className="font-bold"
          >
            {post.authorName}
          </Typography>
          {authorBlocked && (
            <Typography
              as="span"
              variant="body"
              size="small"
              fontWeight="medium"
              className="text-[#E5322D]"
            >
              Blocked
            </Typography>
          )}
        </div>
        <Typography
          as="span"
          variant="body"
          size="small"
          className="text-[#9E9E9E]"
        >
          {post.timeAgo}
        </Typography>
      </div>
      <span className="ml-auto flex shrink-0 items-center gap-1 rounded-md bg-[#FEECEC] px-2 py-1 text-[#E5322D]">
        <FontAwesomeIcon icon={faFlag} className="text-xs" />
        <Typography as="span" variant="body" size="small" fontWeight="medium">
          {`${post.reportCount} reports`}
        </Typography>
      </span>
    </div>

    <Typography variant="body" size="medium" className="text-[#131313]">
      {post.text}
    </Typography>

    {post.reasons.length > 0 && (
      <div className="flex flex-wrap gap-2">
        {post.reasons.map((reason) => (
          <span
            key={reason}
            className="rounded-md bg-[#FEECEC] px-2 py-1 text-[#E5322D]"
          >
            <Typography
              as="span"
              variant="body"
              size="small"
              fontWeight="medium"
            >
              {reason}
            </Typography>
          </span>
        ))}
      </div>
    )}

    <div className="flex flex-wrap gap-2">
      <Button color="error" onClick={onRemove} disabled={busy}>
        {post.isReply ? 'Delete reply' : 'Delete post'}
      </Button>
      <Button color="neutral" onClick={onApprove} disabled={busy}>
        {post.isReply ? 'Keep reply' : 'Keep post'}
      </Button>
      {!authorBlocked && (
        <Button color="neutral" onClick={onBlock} disabled={busy}>
          Block user
        </Button>
      )}
    </div>
  </div>
);
